var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasyRecall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 35,
    viewBox: "0 0 34 35",
    width: 34,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 17.223937,
    fill: "#ea956a",
    rx: 17,
    ry: 17.223937
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.5 11h6.6666667c1.3807118 0 2.5 1.1192881 2.5 2.5v7c0 1.3807119-1.1192882 2.5-2.5 2.5h-6.6666667c-1.3807119 0-2.5-1.1192881-2.5-2.5v-7c0-1.3807119 1.1192881-2.5 2.5-2.5zm3.3296892 3.4780328c-1.7629154 0-3.2823151 1.0038999-3.9802787 2.4525971-.0214362.0438999-.0214362.0952545 0 .1399827.6979636 1.4486889 2.2173719 2.4525971 3.9802787 2.4525971 1.7629067 0 3.2823151-1.0039 3.9802786-2.4525971.0214363-.0438999.0214363-.0952545 0-.1399827-.6979635-1.4486972-2.2173633-2.4525971-3.9802786-2.4525971zm7.1193727-.6888668 2-1.4107528c.3008709-.2122272.7168192-.1403673.9290465.1605036.0793138.1124418.1218916.2466712.1218916.3842715v8.1420946c0 .3681898-.2984768.6666666-.6666667.6666666-.138381 0-.2733326-.0430618-.3861381-.123213l-2-1.4210527c-.1759872-.1250436-.2805285-.3275661-.2805285-.5434536v-5.3102891c0-.216695.1053201-.4198706.2823952-.5447751zm-7.0323952 4.7897814c-.8744509 0-1.5833334-.6715729-1.5833334-1.5 0-.8284272.7088825-1.5 1.5833334-1.5.8744508 0 1.5833333.6715728 1.5833333 1.5 0 .8284271-.7088825 1.5-1.5833333 1.5z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyRecall);
export default __webpack_public_path__ + "static/media/easy_recall.047e33255744547a6de4402e87d5c8e4.svg";
export { ForwardRef as ReactComponent };